import { createFileRoute } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/PageShell";

export const Route = createFileRoute("/impressum")({
  head: () => ({
    meta: [
      { title: "Impressum — Comm42" },
      { name: "description", content: "Impressum / note legali di Comm42 SA, società di diritto svizzero con sede a Mesocco." },
      { property: "og:title", content: "Impressum — Comm42" },
      { property: "og:description", content: "Impressum di Comm42 SA." },
      { property: "og:url", content: "https://comm42.ch/impressum" },
    ],
    links: [{ rel: "canonical", href: "https://comm42.ch/impressum" }],
  }),
  component: ImpressumPage,
});

function ImpressumPage() {
  return (
    <PageShell>
      <PageHero eyebrow="LEGALE" title="Impressum" subtitle="Note legali ai sensi della legislazione svizzera." />
      <section className="mx-auto max-w-3xl px-6 py-16 prose prose-invert prose-headings:font-serif prose-a:text-primary">
        <h2>Ragione sociale</h2>
        <p><strong>Comm42 SA</strong></p>

        <h2>Sede legale</h2>
        <p>a la brona de Darba 7<br />6563 Mesocco<br />Canton Grigioni, Svizzera</p>

        <h2>Contatti</h2>
        <p>
          Telefono: <a href="tel:+41918311215">+41 0918311215</a><br />
          Email: <a href="mailto:sales@comm42.eu">sales@comm42.eu</a><br />
          Amministrazione: <a href="mailto:administration@comm42.eu">administration@comm42.eu</a>
        </p>

        <h2>Forma giuridica</h2>
        <p>Società anonima (SA) di diritto svizzero, iscritta nel Registro di commercio del Canton Grigioni.</p>

        <h2>Esclusione di responsabilità</h2>
        <p>I contenuti di questo sito sono forniti a scopo informativo. Comm42 SA non assume alcuna responsabilità per la correttezza, completezza o attualità delle informazioni pubblicate, né per eventuali danni derivanti dall'uso dei contenuti o dei link verso siti esterni.</p>

        <h2>Diritto d'autore</h2>
        <p>Tutti i contenuti del sito (testi, immagini, loghi, grafica) sono di proprietà di Comm42 SA o dei rispettivi titolari e sono protetti dalle leggi sul diritto d'autore. Ogni riproduzione, anche parziale, richiede l'autorizzazione scritta del titolare.</p>

        <h2>Foro competente</h2>
        <p>Per ogni controversia relativa all'utilizzo del presente sito è competente il foro di Mesocco, Svizzera. Si applica il diritto svizzero.</p>
      </section>
    </PageShell>
  );
}